export enum EnumWritingStep {
  Introduction = 'Introduction',
  Exam = 'Exam',
}

export enum WritingGradeMethodEnum {
  Teacher = 'teacher',
  AI = 'AI',
}
